export function hasAdminAccess(user) {
  return user?.role === "admin";
}

export function hasAdminOrEditorAccess(user) {
  return user?.role === "admin" || user?.role === "editor";
}

export function hasSubscriberAccess(user) {
  return user?.subscribed;
}
